export default __webpack_public_path__ + "app/images/theme-images/light/upload-file-btn/upload-file-btn@2x.webp";